import { Component, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'slide-over',
  templateUrl: 'slide-over.html',
})
export class SlideOverComponent {
  private _visible: boolean = false;
  private _animationTimeout;
  protected _firstShown = false;
  protected _fullyHidden = true;

  get visible() {
    return this._visible;
  }

  @Input()
  closeButton = true;

  @Input()
  icon = '💬';

  @Input()
  fullScreen = false;

  @Input()
  showTitleIcon = false;

  @Input()
  set visible(value: boolean) {
    setTimeout(() => {
      this.zone.run(() => {
        this._visible = value;
        clearTimeout(this._animationTimeout);
        if (value) {
          this._visible = value;
          this._fullyHidden = false;
          if (!this._firstShown) {
            this.firstShown.emit();
          }
          this._firstShown = true;
          this.shown.emit();
        } else {
          this._animationTimeout = setTimeout(() => {
            this._fullyHidden = true;
          }, 500);
          this._visible = value;
          this.hidden.emit();
        }
      }, 10);
    }, 10);
  }

  @Output() firstShown = new EventEmitter();
  @Output() shown = new EventEmitter();
  @Output() hidden = new EventEmitter();

  constructor(public zone: NgZone, public tools: ToolsProvider) {
    this.tools.on('viewWillEnter', () => {
      // immediate hide when page changes
      this._visible = false;
      this._fullyHidden = true;
    });
  }

  ngOnInit() {
    // console.log('show title icon === ', this.titleIcon);
  }

  hide() {
    this.visible = false;
    this.hidden.emit();
  }

  show() {
    this.visible = true;
  }
}



// WEBPACK FOOTER //
// ./src/components/slide-over/slide-over.ts